export const formatDate = (timestamp: number): string => {
  const date = new Date(timestamp);
  
  // 获取用户的语言环境
  const userLocale = navigator.language || 'en-US';
  
  // 完整的日期时间格式
  return date.toLocaleString(userLocale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false // 使用24小时制
  });
}; 